import React from 'react'

function CampaignFundDetails(props) {
  const { header, fundName, url, descriptionText } = props

  return (
    <div className="u-sizeConstrained">
      <div className="Window u-posFixed u-inlineBlock">
        <div className="Window-content u-bgColorWhite u-posAbsolute">
          <input type="checkbox" id="expand-toggle" />
          <label
            htmlFor="expand-toggle"
            id="expand-btn"
            className="Window-heading u-textCenter u-inlineBlock u-textSecondary"
          >
            {header}
            <span className="Icon--material"></span>
          </label>
          <div className="u-paddingHoriz4gu expandable">
            <p className="u-textCenter u-paddingVert4gu">
              {descriptionText} {fundName}
            </p>
            <div className="u-marginHoriz7gu">
              <a
                className="Button Button--secondary Button--block u-sm-sizeFull"
                href={url}
              >
                LEARN MORE
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CampaignFundDetails
